import React from 'react'
import { getParams } from 'utils/helpers'
import { useHistory } from 'react-router-dom'
import { Loading } from 'App/components/Loading/Loading'
import { ErrorInfo } from 'App/components/ErrorInfo/ErrorInfo'
import { SuccessInfo } from 'App/components/SuccessInfo/Success'
import { apiCompanies } from 'services/apiCompanies'
import { loggerInfo } from 'utils/infoLogs'

export const AppointmentConfirmationTerms = (): JSX.Element => {
	const [isLoading, setLoading] = React.useState(true)
	const [hasError, setError] = React.useState(false)
	const history = useHistory()
	const handlePostConsent = async () => {
		try {
			await apiCompanies.post('/appointments/consent-terms/confirm')
		} catch (error) {
			loggerInfo({
				data: error,
				context: 'appointment-confirmation',
				location: 'handlePostConsent',
			})
			setError(true)
		} finally {
			setLoading(false)
		}
	}

	const fetchParams = async () => {
		const { token } = await getParams()
		history.push({
			pathname: '/candidato/confirmacion-cita-termo',
			search: `?token=${token}`,
		})
		handlePostConsent()
	}

	React.useEffect(() => {
		document.title = 'Confirmacion de consentimiento.'
		fetchParams()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (hasError) return <ErrorInfo />

	if (isLoading) return <Loading />

	return <SuccessInfo customMessage="Términos aceptados con éxito" />
}
